import { Component, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { UpdateService } from '../../core/services/update.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'brt-app-update',
  standalone: true,
  imports: [],
  templateUrl: './app-update.component.html',
  styleUrl: './app-update.component.css'
})
export class AppUpdateComponent {
  private snackBar = inject(MatSnackBar);

  @Input() alertInterval: number = 5 * 60;

  constructor(private update: UpdateService) {
    update.updateAvailable$.pipe(takeUntilDestroyed()).subscribe(() => {
      this.alertUpdate();

      interval(this.alertInterval * 1000).subscribe(() => this.alertUpdate());
    });
  }

  alertUpdate() {
    const snackbarRef = this.snackBar.open('A new version of the app is available. Refresh to update.', 'Refresh');
    snackbarRef.onAction().subscribe(() => location.reload());
  }

  test() {
    this.update.test();
  }

}
